import React from "react";
import { CostCentersSearch } from "./cost-centers-search";

export function CostCentersSearchPage() {
  return <CostCentersSearch />;
}
